import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import Button from 'portal-modules/common/components/Button'
import RpModal from './rp-modal'

import { rateFrequency } from 'portal-modules/renewals/components/RenewalOfferTable'
import {
  StyledWrapperUL,
  StyledWrapperMarginUL,
  StyledListItemText,
  StyledSpiltSpanText,
  StyledCloseButton,
  StyledName,
  StyledAmountSpan,
  StyledConditionButton,
} from 'portal-modules/renewals/components/atoms'
import { ModalControl } from '@entrata/portals-common/lib/components'
import { RequestContentModal } from 'portal-modules/common/components/modals'

const special_type_gift_incentive = 2

const OtherChargesModal = ({
  modalTitle,
  other_charge_amount,
  other_charges,
  rate_frequency,
  taxLabel,
  includeTaxesInAdvertisedPricing,
  total_other_charge_tax,
  total_incentive_tax_amount,
  ...rest
}) => {
  const total_amount =
    (includeTaxesInAdvertisedPricing && other_charge_amount) ||
    other_charge_amount + total_other_charge_tax
  return (
    <RpModal
      {...rest}
      title={modalTitle || __('Other Charges')}
      footerContent={
        <StyledCloseButton appearance='primary' onClick={rest.onClose}>
          {__('Close')}
        </StyledCloseButton>
      }
    >
      <StyledWrapperUL>
        {other_charges.map(
          ({
            id,
            special_group_name,
            specials,
            special_count,
            special_limit,
            concessions_count,
            gifts_count,
            terms_and_conditions,
          }) => (
            <Fragment key={id}>
              <StyledListItemText>
                <span>{special_group_name}</span>
              </StyledListItemText>
              {specials.length > 1 && (
                <StyledSpiltSpanText>
                  {__(
                    'Concession ({%d, 0}), Gift ({%d, 1}) | Select {%d, 2} of {%d, 3} Incentives',
                    [
                      concessions_count,
                      gifts_count,
                      special_limit,
                      special_count,
                    ],
                  )}
                  <ModalControl>
                    {({ onClick, ref, ...modalProps }) => (
                      <Fragment>
                        <StyledConditionButton
                          type='button'
                          onClick={onClick}
                          ref={ref}
                        >
                          {__('Terms & Conditions')}
                        </StyledConditionButton>
                        <RequestContentModal
                          {...modalProps}
                          title={__('Terms & Conditions')}
                        >
                          {terms_and_conditions}
                        </RequestContentModal>
                      </Fragment>
                    )}
                  </ModalControl>
                </StyledSpiltSpanText>
              )}
              {specials.length === 1 ? (
                specials.map(
                  ({
                    charge_amount,
                    special_type_id,
                    special_name,
                    tax_amount,
                  }) => (
                    <StyledListItemText>
                      <StyledSpiltSpanText>
                        <span>
                          {special_type_gift_incentive != special_type_id
                            ? __(' Concession | {%s, 0} | Tax : {%m, 1}', [
                                special_name,
                                tax_amount,
                              ])
                            : __(' Gift ')}
                        </span>
                        <ModalControl>
                          {({ onClick, ref, ...modalProps }) => (
                            <Fragment>
                              <StyledConditionButton
                                type='button'
                                onClick={onClick}
                                ref={ref}
                              >
                                {__('Terms & Conditions')}
                              </StyledConditionButton>
                              <RequestContentModal
                                {...modalProps}
                                title={__('Terms & Conditions')}
                              >
                                {terms_and_conditions}
                              </RequestContentModal>
                            </Fragment>
                          )}
                        </ModalControl>
                      </StyledSpiltSpanText>
                      {charge_amount !== 0 && (
                        <StyledAmountSpan>
                          {special_type_gift_incentive != special_type_id &&
                            i18nUtils.currency(charge_amount, 'p:2')}
                          {rateFrequency(rate_frequency)}
                        </StyledAmountSpan>
                      )}
                    </StyledListItemText>
                  ),
                )
              ) : (
                <StyledWrapperMarginUL>
                  {specials.map(
                    ({
                      charge_amount,
                      special_type_id,
                      special_name,
                      tax_amount,
                    }) => (
                      <StyledListItemText>
                        <StyledSpiltSpanText>
                          <StyledName>{special_name}</StyledName>
                          {special_type_gift_incentive != special_type_id
                            ? __(' Concession | Tax : {%m, 0}', [tax_amount])
                            : __(' Gift')}
                        </StyledSpiltSpanText>
                        {charge_amount !== 0 && (
                          <StyledAmountSpan>
                            {special_type_gift_incentive != special_type_id &&
                              i18nUtils.currency(charge_amount, 'p:2')}
                            {rateFrequency(rate_frequency)}
                          </StyledAmountSpan>
                        )}
                      </StyledListItemText>
                    ),
                  )}
                </StyledWrapperMarginUL>
              )}
            </Fragment>
          ),
        )}
      </StyledWrapperUL>
    </RpModal>
  )
}

OtherChargesModal.propTypes = {
  other_charges: PropTypes.array.isRequired,
  modalTitle: PropTypes.string,
  other_charge_amount: PropTypes.number,
  rate_frequency: PropTypes.string,
  includeTaxesInAdvertisedPricing: PropTypes.bool,
  total_other_charge_tax: PropTypes.number,
  taxLabel: PropTypes.string,
}

export default OtherChargesModal
